<script setup>
import { onMounted, ref } from "vue";
import router from "@/router";
import { permissionsStore } from "@/stores/permissions";
const permissions = permissionsStore();

const items = ref([]);

permissions.$subscribe(() => {
  buildSidebarItems();
  loadFirstPage();
});

const allItems = [
  {
    title: "GSX Tokens",
    icon: "mdi-check-circle-outline",
    link: "RepairsAuthCheck",
    privName: "GrantAuthCheck",
    value: false,
  },
  {
    title: "Manage DPD",
    icon: "mdi-truck-delivery",
    link: "RepairsManageDPD",
    privName: "GrantManageDPD",
    value: false,
  },
];

function buildSidebarItems() {
  items.value.length = 0;
  allItems.forEach((item) => {
    if (permissions.$state["Repairs-" + item.privName]) {
      items.value.push(item);
    }
  });
}

onMounted(async () => {
  buildSidebarItems();
  loadFirstPage();
});

function loadFirstPage() {
  if (!router.currentRoute.value.name) {
    if (items.value.length > 0) {
      router.push({ name: items.value[0].link });
    }
  }
}

// Required to make the router-view reload when user clicks the link again
// See the key value set on <router-view> below.
const randomKey = ref("");
function updateRandom() {
  randomKey.value = (Math.random() + 1).toString(36).substring(7);
}
</script>

<template>
  <v-navigation-drawer permanent width="190" theme="jigsawDark">
    <v-list>
      <div class="v-list-item">
        <v-icon class="pa-3" color="#e7541e">mdi-wrench</v-icon>
        <div class="text-h7 pl-2 cursor-default">
          <strong>Repairs</strong>
        </div>
      </div>
      <template v-for="item in items" :key="item.title">
        <v-list-item
          link
          :to="{ name: item.link }"
          @click="updateRandom()"
          class="sideBarListItem"
        >
          <template v-slot:prepend>
            <v-icon class="">{{ item.icon }}</v-icon>
          </template>
          <v-list-item-title class="pa-0">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
  <v-main>
    <v-container fluid>
      <router-view :key="randomKey" />
    </v-container>
  </v-main>
</template>

<style scoped>
.sideBarListItem :deep(.v-list-item__prepend .v-list-item__spacer) {
  width: 10px !important;
}
</style>
